/* Extras site — Le Temple du Foot (28/10/2026)
   Déplace les blocs rendus par sections/ltdf-extras.liquid à leur place dans la home,
   ajoute le compte à rebours au bandeau 3+1, les compteurs UGC, et gère « Trouver mon maillot ». */
(function(){
  var root=document.getElementById('ltdf-extras');if(!root)return;
  var isHome=root.getAttribute('data-template')==='index';
  function sec(suffix){return document.querySelector('.shopify-section[id$="__'+suffix+'"]')||document.querySelector('.shopify-section[id*="__'+suffix+'"]');}
  function pad(n){return (n<10?'0':'')+n;}

  /* ---------- déplacement des blocs ---------- */
  function place(){
    var hide=root.getAttribute('data-hide');if(hide){var h=sec(hide);if(h)h.style.display='none';}
    root.querySelectorAll('.lx-move').forEach(function(el){
      var a=el.getAttribute('data-anchor'),target=null;
      if(a==='duo'){target=document.querySelector('.lx-duo:not(#ltdf-extras .lx-duo)');}
      else if(a==='ugc'){var iga=document.querySelector('.iga');if(iga){var w=document.createElement('div');w.className='lx-ugc-link-wrap';iga.appendChild(w);w.appendChild(el);return;}}
      else{target=sec(a);}
      if(target){target.insertAdjacentElement('afterend',el);}
    });
    var main=document.getElementById('MainContent');
    root.querySelectorAll('.lx-move').forEach(function(el){if(main)main.appendChild(el);});
    root.querySelectorAll('.lx-finder-btn,.lx-finder').forEach(function(el){document.body.appendChild(el);});
  }

  /* ---------- bande réassurance avant le pied de page (toutes pages) ---------- */
  function foot(){
    var band=root.querySelector('.lx-mq--foot');if(!band)return;
    var f=document.querySelector('.shopify-section-group-footer-group');
    if(f){f.insertAdjacentElement('beforebegin',band);}else{document.body.appendChild(band);}
  }

  /* ---------- rangées produits : flèches + barre ---------- */
  function rows(){
    document.querySelectorAll('.lx-row').forEach(function(row){
      var track=row.querySelector('[data-lx-track]'),bar=row.querySelector('[data-lx-bar]');if(!track)return;
      function step(){var c=track.querySelector('.lx-pcard');return c?c.getBoundingClientRect().width+16:300;}
      function upd(){if(!bar)return;var max=track.scrollWidth-track.clientWidth;var w=max>0?Math.max(12,track.clientWidth/track.scrollWidth*100):100;bar.style.width=w+'%';bar.style.transform='translateX('+(max>0?(track.scrollLeft/max)*(100/w*100-100):0)+'%)';}
      row.querySelector('[data-lx-prev]').addEventListener('click',function(){track.scrollBy({left:-step()*2,behavior:'smooth'});});
      row.querySelector('[data-lx-next]').addEventListener('click',function(){track.scrollBy({left:step()*2,behavior:'smooth'});});
      track.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);upd();
    });
  }

  /* ---------- bandeau 3+1 : carte propre + compte à rebours ---------- */
  function b3(){
    if(root.getAttribute('data-b3')!=='true')return;
    var wrap=document.querySelector('.b3-wrap');if(!wrap||wrap.classList.contains('lx-b3'))return;
    var end=new Date(root.getAttribute('data-b3-end')||'').getTime();if(!end||isNaN(end))return;
    function txt(sel,def){var el=wrap.querySelector(sel);return el?el.textContent.trim():def;}
    var label=txt('.b3-label','Offre pack en cours');
    var title=txt('.b3-hl',txt('.b3-titre','3 achetés = 1 offert'));
    var descEl=wrap.querySelector('.b3-desc');var desc=descEl?descEl.innerHTML:'';
    var d=new Date(end);var until='Jusqu’au '+d.getDate()+' '+['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'][d.getMonth()];
    var esc=function(s){return s.replace(/&/g,'&amp;').replace(/</g,'&lt;');};
    wrap.classList.add('lx-b3');
    wrap.innerHTML='<div class="lx-b3-card">'
      +'<div class="lx-b3-kick"><span>'+esc(label)+'</span><small>'+until+'</small></div>'
      +'<h3 class="lx-b3-title">'+esc(title)+'</h3>'
      +'<div class="lx-b3-count" aria-label="Temps restant"><b><span data-u="d">00</span><i>j</i></b><em>:</em><b><span data-u="h">00</span><i>h</i></b><em>:</em><b><span data-u="m">00</span><i>min</i></b><em>:</em><b><span data-u="s">00</span><i>sec</i></b></div>'
      +(desc?'<p class="lx-b3-desc">'+desc+'</p>':'')
      +'</div>';
    var c=wrap.querySelector('.lx-b3-count');
    function tick(){var diff=end-Date.now();if(diff<0)diff=0;var v={d:Math.floor(diff/864e5),h:Math.floor(diff%864e5/36e5),m:Math.floor(diff%36e5/6e4),s:Math.floor(diff%6e4/1e3)};c.querySelectorAll('[data-u]').forEach(function(s){s.textContent=pad(v[s.getAttribute('data-u')]);});}
    tick();setInterval(tick,1000);
  }

  /* ---------- UGC : compteurs likes / commentaires / partages ---------- */
  function ugc(){
    if(root.getAttribute('data-ugc')!=='true')return;
    var dataEl=document.getElementById('lxUgcData');if(!dataEl)return;
    var raw='';try{raw=JSON.parse(dataEl.textContent||'""')||'';}catch(e){return;}
    var map={};raw.split(/\r?\n/).forEach(function(l){var p=l.split('|');if(p[0]&&p[0].trim())map[p[0].trim().replace(/^@/,'').toLowerCase()]={likes:p[1]||'',com:p[2]||'',share:p[3]||'',url:(p[4]||'').trim()};});
    function fmt(n){n=parseInt(String(n).replace(/\s/g,''),10);if(isNaN(n))return '';if(n>=1000)return (Math.round(n/100)/10).toString().replace('.',',')+' K';return String(n);}
    var H='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"><path d="M12 20.5s-7.5-4.6-7.5-10A4 4 0 0 1 12 8a4 4 0 0 1 7.5 2.5c0 5.4-7.5 10-7.5 10z"/></svg>';
    var C='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"><path d="M12 3.5c-4.7 0-8.5 3.2-8.5 7.2 0 2.2 1.1 4.1 2.9 5.4L5.5 20l4.3-1.9c.7.1 1.4.2 2.2.2 4.7 0 8.5-3.2 8.5-7.2S16.7 3.5 12 3.5z"/></svg>';
    var S='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round" stroke-linecap="round"><path d="M21 3 10.5 13.5M21 3l-6.5 18-4-7.5L3 9.5z"/></svg>';
    var B='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"><path d="M6.5 3.5h11v17L12 16.5l-5.5 4z"/></svg>';
    document.querySelectorAll('.iga-card:not(.lx-ugc)').forEach(function(card){
      var h=card.querySelector('.iga-handle');if(!h)return;var key=(h.textContent||'').trim().replace(/^@/,'').toLowerCase();var d=map[key];
      card.classList.add('lx-ugc');if(!d)return;
      var bar=card.querySelector('.iga-bar');if(!bar)return;
      var st=document.createElement('div');st.className='lx-ugc-stats';
      st.innerHTML='<span>'+H+fmt(d.likes)+'</span><span>'+C+fmt(d.com)+'</span><span>'+S+fmt(d.share)+'</span><span class="lx-save">'+B+'</span>';
      bar.appendChild(st);
      if(d.url){var ig=card.querySelector('.iga-ig');if(ig&&!ig.querySelector('a')){var a=document.createElement('a');a.href=d.url;a.target='_blank';a.rel='noopener';a.setAttribute('aria-label','Voir le post');a.style.cssText='position:absolute;inset:0;';card.style.position='relative';card.appendChild(a);}}
    });
  }

  /* ---------- liens à rediriger (réglage « Liens à rediriger ») ---------- */
  function links(){
    var raw=root.getAttribute('data-links')||'';if(!raw.trim())return;
    var map=[];raw.split(/\r?\n/).forEach(function(l){var p=l.split('|');if(p[0]&&p[1]&&p[0].trim()&&p[1].trim())map.push([p[0].trim(),p[1].trim()]);});
    if(!map.length)return;
    function fix(){document.querySelectorAll('a[href]').forEach(function(a){var h=a.getAttribute('href');if(!h)return;map.forEach(function(m){if(h===m[0]||h.indexOf(m[0]+'?')===0||h.indexOf(m[0]+'#')===0){a.setAttribute('href',m[1]+h.slice(m[0].length));}});});}
    fix();new MutationObserver(fix).observe(document.body,{childList:true,subtree:true});
  }

  /* ---------- Trouver mon maillot ---------- */
  function finder(){
    var btn=document.getElementById('lxFinderBtn'),box=document.getElementById('lxFinder');if(!btn||!box)return;
    function open(){box.hidden=false;requestAnimationFrame(function(){box.classList.add('is-on');var i=document.getElementById('lxFinderInput');if(i&&window.innerWidth>749)i.focus();});}
    function close(){box.classList.remove('is-on');setTimeout(function(){box.hidden=true;},200);}
    btn.addEventListener('click',open);
    box.querySelectorAll('[data-lx-close]').forEach(function(el){el.addEventListener('click',close);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!box.hidden)close();});
    /* on masque le bouton quand le jeu à gratter est ouvert */
    var sc=document.getElementById('ltdf-scratch');
    if(sc){new MutationObserver(function(){btn.style.display=sc.hidden?'':'none';}).observe(sc,{attributes:true,attributeFilter:['hidden']});}
  }

  function boot(){
    if(isHome){place();rows();b3();ugc();}else{root.querySelectorAll('.lx-finder-btn,.lx-finder').forEach(function(el){document.body.appendChild(el);});}
    foot();finder();links();
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
